import { z } from 'zod';
import { shippingPartySchema } from './transportExecution.shipments.schema';

const transportOrderAddressSchema = z.object({
    street: z.string(),
    city: z.string(),
    postal_code: z.string(),
    country_code: z.string(),
});

const transportOrderTimeWindowSchema = z.object({
    from: z.iso.datetime(),
    to: z.iso.datetime(),
});

const transportOrderHandlingUnitContentSchema = z.object({
    code: z.string(),
    quantity: z.number().int(),
});

const transportOrderHandlingUnitSchema = z.object({
    code: z.string(),
    quantity: z.number().int(),
    total_weight_kg: z.number().nullish(),
    total_volume_m3: z.number().nullish(),
    content: z.array(transportOrderHandlingUnitContentSchema),
});

const transportOrderShippingPartyWithAddressSchema = z.object({
    duns: z.string(),
    name: z.string().nullish(),
    supplier_code: z.string().nullish(),
    handling_location_id: z.string().nullish(),
    plant_code: z.string().nullish(),
    address: transportOrderAddressSchema.nullable(),
});

const transportOrderShippingPartySchema = shippingPartySchema.extend({
    name: z.string().nullish(),
});

const transportOrderConfirmationSchema = z.object({
    first_confirmed_at: z.iso.datetime(),
    confirmed_at: z.iso.datetime(),
    freight_forwarder: transportOrderShippingPartySchema,
    transport_chain_reference: z.string(),
    confirmed_pickup_time_window: transportOrderTimeWindowSchema.nullish(),
    license_plate: z.string().nullish(),
});

const transportOrdersForShipmentSchema = z.object({
    transport_order_id: z.string(),
    transport_order_number: z.string(),
    transport_leg_number: z.number().int().nullish(),
    ship_from: transportOrderShippingPartyWithAddressSchema,
    ship_to: transportOrderShippingPartyWithAddressSchema,
    freight_forwarder: transportOrderShippingPartySchema,
    total_weight_kg: z.number().optional(),
    total_volume_m3: z.number().optional(),
    handling_units: z.array(transportOrderHandlingUnitSchema),
    pickup_time_window: transportOrderTimeWindowSchema,
    ordered_at: z.iso.datetime(),
    confirmation: transportOrderConfirmationSchema.nullish(),
});

export const transportOrdersForShipmentsResponseSchema = z.object({
    shipment_id: z.string(),
    transport_orders: z.array(transportOrdersForShipmentSchema),
});
export type ApiTransportOrdersForShipmentsResponse = z.infer<typeof transportOrdersForShipmentsResponseSchema>;
export type ApiTransportOrderForShipment = z.infer<typeof transportOrdersForShipmentSchema>;
export type ApiTransportOrderShippingPartyWithAddress = z.infer<typeof transportOrderShippingPartyWithAddressSchema>;
export type ApiTransportOrderShippingParty = z.infer<typeof transportOrderShippingPartySchema>;
export type ApiTransportOrderAddress = z.infer<typeof transportOrderAddressSchema>;
export type ApiTransportOrderTimeWindow = z.infer<typeof transportOrderTimeWindowSchema>;
export type ApiTransportOrderHandlingUnit = z.infer<typeof transportOrderHandlingUnitSchema>;
export type ApiTransportOrderHandlingUnitContent = z.infer<typeof transportOrderHandlingUnitContentSchema>;
export type ApiTransportOrderConfirmation = z.infer<typeof transportOrderConfirmationSchema>;
